import { render, staticRenderFns } from "./ListPacs.vue?vue&type=template&id=113aadca&scoped=true"
import script from "./ListPacs.vue?vue&type=script&lang=js"
export * from "./ListPacs.vue?vue&type=script&lang=js"
import style0 from "./ListPacs.vue?vue&type=style&index=0&id=113aadca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113aadca",
  null
  
)

export default component.exports